module.exports = __webpack_public_path__ + "8dc7ff1d0510de5def23e96c1d6ddaf9.svg";